import warn from './warn.js';

const alreadyEmittedWarnings = new Set();

// Use this function for deprecation console warnings that should only appear once per session.
const warnDeprecation = deprecationMessage => {
  if (!alreadyEmittedWarnings.has(deprecationMessage)) {
    warn(deprecationMessage);
    alreadyEmittedWarnings.add(deprecationMessage);
  }
};

export { warnDeprecation as default };
